import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import { useSmartTranslation } from '../hooks/useSmartTranslation'
import { systemValueLabel } from './systemValueLabel'
import { ChipLook, OverlineLook, OutlinedLook } from './looks'

/**
 * Story 204 — the ONE component that paints a system value (status, enum, reference row): the text always comes from
 * `systemValueLabel` (RN1.1, RN1.5); the look is the one the screen had before (`chip` = ex StatusPill, `overline` = ex Pill,
 * `outlined` = ex BomStatusChip, `text` = plain span). Renders nothing when there is no text, like BomStatusChip did.
 */
export const SystemValueChip = ({ domain, value, labelKeys = {}, look = 'text', iconKey = '', tone = 'default', color = 'default', icon = null, testId = '', iconTestIdPrefix = 'operation-status-icon' }) => {
  const { t_ } = useSmartTranslation()
  const label = systemValueLabel(t_, domain, value, labelKeys)
  if (label === '') return null
  if (look === 'chip') return <ChipLook iconKey={iconKey} label={label} testId={testId} iconTestIdPrefix={iconTestIdPrefix} />
  if (look === 'overline') return <OverlineLook label={label} tone={tone} icon={icon} testId={testId} />
  if (look === 'outlined') return <OutlinedLook label={label} color={color} testId={testId} />
  return <Box component='span' data-testid={testId || undefined}>{label}</Box>
}

SystemValueChip.propTypes = {
  domain: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  labelKeys: PropTypes.object,
  look: PropTypes.oneOf(['text', 'chip', 'overline', 'outlined']),
  iconKey: PropTypes.string,
  tone: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.node,
  testId: PropTypes.string,
  iconTestIdPrefix: PropTypes.string
}

export default SystemValueChip
